/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForecastDeleteCountList } from '../../models/forecast-delete-count-list';
import { ForecastDeleteList } from '../../models/forecast-delete-list';

export interface DeleteStationForecast$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * list of forecast data to be deleted
     */
    body: ForecastDeleteList
}

export function deleteStationForecast(http: HttpClient, rootUrl: string, params: DeleteStationForecast$Params, context?: HttpContext): Observable<StrictHttpResponse<ForecastDeleteCountList>> {
  const rb = new RequestBuilder(rootUrl, deleteStationForecast.PATH, 'delete');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ForecastDeleteCountList>;
    })
  );
}

deleteStationForecast.PATH = '/stations/{uid}/data/forecast';
